// Constantes physiologiques et UX

/** Verres d'eau quotidiens (250 ml) — vise 3 L/jour */
export const WATER_GLASSES_TARGET = 12;
export const WATER_GLASS_ML = 250;

/** Protéines en g par kg de poids corporel — prise de masse sèche */
export const PROTEIN_PER_KG = 2;

/** Surplus calorique sur le TDEE pour prise de masse sèche */
export const KCAL_SURPLUS = 300;

/** Facteur d'activité Mifflin-St Jeor (modérément actif) */
export const ACTIVITY_FACTOR = 1.6;

/** Heures de sommeil cibles */
export const SLEEP_HOURS = 8;

/** Nombre maximum de zones prioritaires sélectionnables à l'onboarding */
export const MAX_PRIORITY_ZONES = 5;

/** Répartition des macros (pourcentage des calories totales) */
export const MACRO_SPLIT = {
  carbs: 0.45,
  fat: 0.25,
} as const;

/** Calories par gramme de macronutriment */
export const KCAL_PER_G = {
  protein: 4,
  carbs: 4,
  fat: 9,
} as const;

/** +1 série bonus aux exos qui touchent une zone prioritaire (cf décision §6.E bonus) */
export const PRIORITY_ZONE_BONUS_SET = 1;

/** Nombre de semaines avant que le programme cycle sur la semaine 4 */
export const PROGRAM_WEEKS = 4;

/** Estimation conservatrice de durée par série non-temporelle (pour affichage estimé) */
export const ESTIMATED_SECONDS_PER_SET = 45;

/** Durée des avertissements sonores avant fin de round */
export const ROUND_END_WARNING_SEC = 10;

/**
 * Multiplicateur de volume (séries) par niveau de fitness.
 * Appliqué après le bonus zones prioritaires.
 *   - beginner : -30% pour ne pas casser personne au démarrage
 *   - intermediate : volume nominal du programme (référence)
 *   - advanced : +30% pour pousser ceux qui ont déjà du fond
 */
export const LEVEL_VOLUME_FACTOR = {
  beginner: 0.7,
  intermediate: 1,
  advanced: 1.3,
} as const;

/**
 * Multiplicateur de reps cibles (numériques) par niveau.
 * Appliqué aux reps quand elles sont des nombres (pas AMRAP, pas '8 / jambe').
 */
export const LEVEL_REPS_FACTOR = {
  beginner: 0.8,
  intermediate: 1,
  advanced: 1.4,
} as const;
